import types from 'actions/types'
import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'
import {getFilterFromAction} from 'helpers/reducer'

export const contactsContextActivitiesTabPivotTableKey = 'contactsContext.selected.activitiesTab.pivotTable'

const showCompleted = (state = false, action) => {
  switch (action.type) {
    case types.CONTACTS_ACTIVITIES_UPDATE_FILTERS:
      return getFilterFromAction(state, action, 'showCompleted')
    default:
      return state
  }
}

const showRejected = (state = false, action) => {
  switch (action.type) {
    case types.CONTACTS_ACTIVITIES_UPDATE_FILTERS:
      return getFilterFromAction(state, action, 'showRejected')
    default:
      return state
  }
}

export const showAllContacts = (state = false, action) => {
  switch (action.type) {
    case types.CONTACTS_ACTIVITIES_UPDATE_FILTERS:
      return getFilterFromAction(state, action, 'showAllContacts')
    default:
      return state
  }
}

export default combineReducers({
  showCompleted,
  showRejected,
  showAllContacts,
  pivotTable: createPivotTableReducer({key: contactsContextActivitiesTabPivotTableKey, defaultSortColumn: 'startDate'}),
})
